"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _SVGIcon = _interopRequireDefault(require("@instructure/ui-svg-images/lib/components/SVGIcon"));

var _ref =
/*#__PURE__*/
_react.default.createElement("path", {
  d: "M1637.706 112.941c93.403 0 169.412 76.01 169.412 169.412V1920H113V282.353c0-93.402 76.009-169.412 169.412-169.412h169.41v-56.47c0-31.172 25.3-56.47 56.472-56.47s56.47 25.298 56.47 56.47v56.47h790.589v-56.47c0-31.172 25.299-56.47 56.47-56.47 31.172 0 56.47 25.298 56.47 56.47v56.47h169.413zm56.47 338.824V282.353c0-31.172-25.411-56.47-56.47-56.47h-169.412v56.47c0 31.172-25.3 56.471-56.47 56.471-31.172 0-56.471-25.299-56.471-56.47v-56.472H564.765v56.471c0 31.172-25.3 56.471-56.471 56.471-31.171 0-56.471-25.299-56.471-56.47v-56.472H282.412c-31.06 0-56.47 25.3-56.47 56.471v169.412h1468.234zM225.942 1807.058h1468.234V564.705H225.942v1242.353zm112.94-677.646V790.588h338.824v338.824H338.882zm112.942-112.941h112.941V903.53H451.824v112.941zm338.823 112.941V790.588h338.824v338.824H790.647zm112.941-112.941h112.941V903.53H903.588v112.941zm338.824 112.941V790.588h338.823v338.824h-338.823zm112.941-112.941h112.941V903.53h-112.941v112.941zM338.882 1581.177v-338.824h338.824v338.824H338.882zm112.942-112.942h112.941v-112.941H451.824v112.941zm338.823 112.942v-338.824h338.824v338.824H790.647zm112.941-112.942h112.941v-112.941H903.588v112.941zm338.824 112.942v-338.824h338.823v338.824h-338.823zm112.941-112.942h112.941v-112.941h-112.941v112.941z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconCalendarMonth =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(IconCalendarMonth, _Component);

  function IconCalendarMonth() {
    (0, _classCallCheck2.default)(this, IconCalendarMonth);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(IconCalendarMonth).apply(this, arguments));
  }

  (0, _createClass2.default)(IconCalendarMonth, [{
    key: "render",
    value: function render() {
      return _react.default.createElement(_SVGIcon.default, Object.assign({}, this.props, {
        name: "IconCalendarMonth",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);
  IconCalendarMonth.displayName = "IconCalendarMonth";
  return IconCalendarMonth;
}(_react.Component);

exports.default = IconCalendarMonth;
IconCalendarMonth.glyphName = 'calendar-month';
IconCalendarMonth.variant = 'Line';
IconCalendarMonth.propTypes = (0, _objectSpread2.default)({}, _SVGIcon.default.propTypes);